import React from "react";
import styled from "styled-components";

import { BREAK_POINTS } from '../../../constants';

const PressItemWrapper = styled.div`
  width: 980px;
  height: 200px;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    width: 100%;
    height: 180px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    flex-direction: column;
    height: auto;
  }
`;

const PressImage = styled.img`
  width: 280px;
  height: 200px;
  flex-shrink: 0;
  object-fit: cover;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    width: 240px;
    height: 160px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    width: 90%;
    height: 244px;
    
    // 모바일의 경우 이미지 원본 사이즈로 노출
  }
`;

const PressDefaultImage = styled.div`
  width: 280px;
  height: 200px;
  background-color: #d8d8d8;
  flex-shrink: 0;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    width: 240px;
    height: 160px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    width: 90%;
    height: 244px;
  }
`;

const PressTextWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 25px 25px 25px 20px;
`;

const PressTitle = styled.h3`
  margin: 0 0 20px 0;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.83px;
  color: #505050;

  /* 타이틀 최대 두 줄 까지 노출 */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    font-size: 20px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
  }
`;

const PressContent = styled.p`
  margin: 20px 0;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: -0.4px;
  color: #969696;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    font-size: 14px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    display: none;
  }
`;

const PressDate = styled.p`
  margin: 20px 0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.27px;
  color: #949cca;
`;

export default function PressItem({ item, navigateToPressDetail }) {
  
  return (
    <PressItemWrapper onClick={() => navigateToPressDetail(item.id)}>
      {item.image ? <PressImage src={item.image} alt="press" /> : <PressDefaultImage />}
      <PressTextWrapper>
        <PressTitle>{item.title}</PressTitle>
        <PressContent>{item.content}</PressContent>
        <PressDate>{item.date}</PressDate>
      </PressTextWrapper>
    </PressItemWrapper>
  );
}
